function initProductSwiper() {
  var productSwiper = new Swiper('.u-product-slider', {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1200: { slidesPerView: 4 },
      992: { slidesPerView: 3 },
      768: { slidesPerView: 2 },
      250: { slidesPerView: 1 }
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  function aggiornaData() {
    const doubleuspsElement = document.querySelector('.doubleusps');

    if (!doubleuspsElement) {
      console.error('Error: .doubleusps element not found');
      return;
    }
    const giorniDellaSettimana = doubleuspsElement.dataset.giorni.split(',');
    const mesi = doubleuspsElement.dataset.mesi.split(',');
    const nDays = window.nDays || 1;

    const ora = new Date();
    const futureDate = new Date(ora);
    futureDate.setDate(ora.getDate() + nDays);

    const dataFormattata = `${giorniDellaSettimana[futureDate.getDay()]}, ${futureDate.getDate()} ${mesi[futureDate.getMonth()]}`;

    let cstmDate = document.getElementById('cstmdate');
    if (cstmDate) {
      cstmDate.innerText = dataFormattata;
    }

    const msFinoAllaMezzanotte = new Date(ora.setHours(24, 0, 0, 0)) - ora;
    setTimeout(() => {
      aggiornaData();
      setInterval(aggiornaData, 24 * 60 * 60 * 1000);
    }, msFinoAllaMezzanotte);
  }

  aggiornaData();
});

/* ── FORCE: never show variants as sold out (cosmetic only, NOT the add-to-cart form) ──
   FIX (2026-09-06): This used to also watch and rewrite the product-form / variant-
   picker area (variant-input, variant-input-wrap, add-to-cart button) on every click,
   racing against the theme's own variant-selection script that updates the hidden
   variant id (the <select data-product-select> in product-form.liquid) on that same
   click. That race could leave the hidden variant id out of sync with the visually
   selected size/color, so the wrong variant (often the first/default one) got added
   to the cart even though the customer had clicked a different size.
   Since "Continue selling when out of stock" is enabled on these products, Shopify
   already reports every variant as available — this cosmetic override is not needed
   inside the product form at all, so it has been scoped OUT of it entirely below. It
   still cleans up any stray sold-out styling elsewhere on the page (e.g. badges), but
   it no longer touches anything inside .product-single__form / .product-form /
   .variant-input-wrap / the add-to-cart button, and no longer re-scans after clicks
   inside the product form. ── */
(function () {
  // Deliberately EXCLUDES product-form / variant-picker / add-to-cart selectors —
  // those must be left alone so the theme's own variant-selection script can update
  // the hidden variant id without interference. See comment above.
  var DISABLED_SELECTOR = '.u-product-badge.disabled, .collection-grid-item .disabled';

  var isApplying = false;

  function forceEnableVariants(root) {
    if (isApplying) return;
    isApplying = true;

    var scope = root || document;
    var disabledEls = scope.querySelectorAll(DISABLED_SELECTOR);
    disabledEls.forEach(function (el) {
      el.classList.remove('disabled');
      el.removeAttribute('disabled');
      el.style.pointerEvents = 'auto';
      el.style.opacity = '1';
      el.style.textDecoration = 'none';
      el.style.cursor = 'pointer';
    });

    isApplying = false;
  }

  // Run once immediately and once after DOM is ready. No MutationObserver and no
  // click-listener re-scan inside the product form anymore — those were the source
  // of the race condition with the theme's variant-selection script.
  forceEnableVariants();
  document.addEventListener('DOMContentLoaded', function () {
    forceEnableVariants();
  });
})();
